import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>
            Here are some videos from our recent events and activities.
          </p>
        </div>
        
        {/* Menggunakan row bawaan Bootstrap */}
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  // Memaksa 3 kolom di Desktop (col-md-4) dan 2 kolom di Tablet (col-sm-6)
                  className="col-xs-12 col-sm-6 col-md-4" 
                  style={{ marginBottom: "40px" }}
                >
                  {/* Kotak Video dengan rasio 16:9 yang terkunci */}
                  <div 
                    className="embed-responsive embed-responsive-16by9" 
                    style={{ 
                      backgroundColor: "#000", 
                      borderRadius: "8px", // Opsional: Biar ujung videonya agak membulat rapi
                      overflow: "hidden",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)" // Opsional: Efek bayangan tipis
                    }}
                  >
                    <iframe
                      className="embed-responsive-item"
                      src={d.youtubeUrl}
                      title={d.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                  
                  {/* Judul dengan tinggi minimum yang dikunci agar tidak merusak baris */}
                  <h4 style={{ 
                    marginTop: "15px", 
                    fontSize: "16px", 
                    fontWeight: "600",
                    lineHeight: "1.4",
                    minHeight: "48px", // INI KUNCINYA: Menyamakan tinggi teks yang pendek & panjang
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    {d.title}
                  </h4>
                </div>
              ))
            : "Loading..."}
        </div>

      </div>
    </div>
  );
};